import React from "react";
import { createPortal } from "react-dom";
import { TIME_PICKER_OPTIONS } from "../constants/upDownConstants";

export function TimePickerOverlay({
  isOpen,
  position,
  activeLayout,
  wallet,
  selectedExpirySeconds,
  selectedExpiryId,
  timerInput,
  panelRef,
  scrollRef,
  selectedTimeOptionRef,
  onSelectOption,
  onClose,
}) {
  if (!isOpen || !position || typeof document === "undefined") {
    return null;
  }

  const timeOptions = (() => {
    const settings = wallet?.binary?.time_settings;
    if (settings?.length) {
      return settings
        .map((s) => ({
          ...s,
          id: s.id || s._id || `custom_${s.seconds}`,
          value:
            s.value ||
            `${Math.floor(s.seconds / 60)}:${(s.seconds % 60)
              .toString()
              .padStart(2, "0")}`,
        }))
        .sort((a, b) => Number(a.seconds) - Number(b.seconds));
    }
    return TIME_PICKER_OPTIONS;
  })();

  return createPortal(
    <>
      {position.isMobileSheet && (
        <button
          type="button"
          aria-label="Close time picker"
          className="fixed inset-0 z-[9997] bg-black/55"
          onClick={onClose}
        />
      )}
      <div
        ref={panelRef}
        role="dialog"
        aria-label="Select trade time"
        className={`z-[9998] overflow-hidden rounded-xl border border-white/10 bg-[#111] p-2 text-white shadow-2xl shadow-black/50 transition-all duration-150 ease-out ${
          position.isMobileSheet
            ? "fixed inset-x-3 bottom-3 animate-[timePickerSheetIn_160ms_ease-out] pb-[calc(0.5rem+env(safe-area-inset-bottom))]"
            : "fixed origin-bottom animate-[timePickerMenuIn_140ms_ease-out]"
        }`}
        style={
          position.isMobileSheet
            ? undefined
            : {
                top: `${position.top}px`,
                left: `${position.left}px`,
                maxWidth:
                  activeLayout && activeLayout !== "single"
                    ? "190px"
                    : "250px",
                width: "100%",
              }
        }
      >
        <div
          ref={scrollRef}
          role="listbox"
          className="max-h-[200px] overflow-y-auto scroll-smooth rounded-lg bg-[#1a1a1a] p-1 [scroll-snap-type:y_mandatory]"
        >
          {timeOptions.map((option) => {
            const optionSeconds = Number(option.seconds);
            const hasMatchingSeconds =
              Number.isFinite(optionSeconds) &&
              optionSeconds === selectedExpirySeconds;
            const isSelected =
              selectedExpiryId === option.id ||
              timerInput === option.value ||
              hasMatchingSeconds;

            return (
              <button
                key={option.id}
                ref={isSelected ? selectedTimeOptionRef : null}
                type="button"
                role="option"
                aria-selected={isSelected}
                className={`mb-1 flex h-10 w-full scroll-my-2 items-center justify-center rounded-xl border px-4 text-sm font-bold transition last:mb-0 [scroll-snap-align:center] ${
                  isSelected
                    ? "border-[#ffd43b] bg-[#ffd43b] text-black shadow-lg shadow-[#ffd43b]/10"
                    : "border-white/5 bg-transparent text-white/80 hover:border-white/15 hover:bg-white/10 active:bg-white/15"
                }`}
                onClick={() => onSelectOption(option)}
              >
                <span>{option.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </>,
    document.body,
  );
}

